export default "/institutions/mercado-pago.svg";